import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import Template from 'components/cases/listpage/ai/Template'

const AI: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta
        keyword={'事例 実績 AI'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/cases/ai/'}
        title="AI | 事例 | Aitria（アイトリア）"
        description="AIのケーススタディを紹介します｜Aitria（アイトリア）はビジネス・デザイン・テクノロジーの力を駆使して、顧客のミッションをあらゆる角度から伴走支援するデジタルイノベーションパートナー事業を展開しています。"
      />
      <Template />
    </>
  )
}

export default AI
